export const APP_FEATURE_KEY = 'app';

export interface AppState {
    version: string,
    title: string,
  }
  
  export const initialAppState: AppState = {
    version: "",
    title: "Willkommen",
  };